module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-assign-locum-66e54606c82d219e5b402461ddd7a86f.svg";